<div class="body" [formGroup]="formGroup">

    <mat-form-field class="width" [appearance]="appearance" formGroupName="issueTransaction">
        <span matPrefix class="number-prefix">
            {{guidControl.value? 'ID: ' + guidControl.value: 'neu'}}
        </span>
        <mat-label>Bezeichnung</mat-label>
        <input formControlName="name" matInput />
    </mat-form-field>

    <app-issue-transaction-issue-type-form class="width" formControlName="issueType"></app-issue-transaction-issue-type-form>

    <div class="row">

        <app-select-status-form multiple="true" formControlName="initialStatus" class="initial-status" label="Verfügbar in Status"></app-select-status-form>

        <ng-container formGroupName="issueTransaction">
    
            <app-select-status-form class="result-status" formControlName="result" label="Resultat"></app-select-status-form>
    
        </ng-container>

    </div>

    <app-select-issue-transaction-attribute formControlName="issueTransactionAttributes" multiple="true"></app-select-issue-transaction-attribute>

    <app-select-default-notification formControlName="defaultNotifications" multiple="true" label="Vorlagen wählen"></app-select-default-notification>

    <div class="default-mail-hint">

        <div class="icon-wrapper">
            <mat-icon>info</mat-icon>
        </div>

        <div class="text">

            Beim Ausführen von Transaktionen können E-Mails voreingestellt werden. 
            Diese werden dem Nutzer angezeigt und können - individuell - ausgelassen werden.

        </div>

        <div class="control-wrapper">

            <button mat-raised-button color="primary" (click)="addMail()">
                Anlegen
            </button>

        </div>

    </div>

    <app-issue-transaction-default-mails [formGroup]="defaultMailArray"></app-issue-transaction-default-mails>

</div>
